// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cyclizar: PokeData = {
  "id": 967,
  "name": "cyclizar",
  "height": 16,
  "weight": 630,
  "base_experience": 175,
  "types": [
    PokeType.DRAGON,
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "bite",
    "growl",
    "quick-attack",
    "rapid-spin",
    "taunt",
    "dragon-claw",
    "u-turn",
    "dragon-pulse",
    "dragon-rush",
    "shift-gear",
    "breaking-swipe",
    "shed-tail"
  ],
  "moves": [
    "tackle",
    "bite",
    "growl",
    "quick-attack",
    "dragon-claw",
    "dragon-pulse",
    "dragon-rush",
    "scratch",
    "outrage",
    "body-slam",
    "inner-spirit",
    "great-roar",
    "refresh"
  ],
  "evolution_chain": {
    "id": 506,
    "item": null,
    "species": [
      {
        "name": "cyclizar",
        "order": 953,
        "types": [
          PokeType.DRAGON,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 95,
    "speed": 171,
    "ability_power": 134
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
